import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 446 334.499',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="plane-departure-solid" transform="translate(-256 -430.508)">
      <path
        fill={fill}
        id="plane-departure-solid-2"
        data-name="plane-departure-solid"
        d="M434.841,321.892H11.149A11.147,11.147,0,0,0,0,333.042v22.3a11.147,11.147,0,0,0,11.15,11.15H434.841a11.147,11.147,0,0,0,11.15-11.15v-22.3A11.147,11.147,0,0,0,434.841,321.892ZM56.131,247.516a22.984,22.984,0,0,0,16.955,7.463l90.968-.125a45.728,45.728,0,0,0,20.655-4.962L387.468,147c18.634-9.456,35.338-22.955,46.7-40.634,12.76-19.847,14.146-34.209,9.108-44.355s-17.24-17.61-40.592-19.129c-20.8-1.352-41.491,4.125-60.125,13.575L273.915,91.294l-152.4-57.184a12.4,12.4,0,0,0-12.544-.774L63.149,56.59a12.733,12.733,0,0,0-3.6,19.881L168.41,144.834l-71.923,36.5L46.069,155.921a12.407,12.407,0,0,0-11.2.014L6.905,170.13A12.738,12.738,0,0,0,3.024,189.7l53.108,57.819Z"
        transform="translate(256.003 398.515)"
      />
    </g>
  </svg>
);

export default SVG;
